import { render, staticRenderFns } from "./onlineChar.vue?vue&type=template&id=638bdea1&"
import script from "./onlineChar.vue?vue&type=script&lang=js&"
export * from "./onlineChar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports